.primary-action-button {
  flex: 1;

  height: 100%;
  align-items: center;
  justify-content: center;
}

.primary-action-button-container {
  min-height: 40px;
}

.primary-action-button-label {
  min-height: 32px;

  display: flex;
  align-items: center;
  line-height: 16px;
}
